import Cookies from 'js-cookie'

// Ad click ids for the Segment Microsoft/Google CAPI destinations: captured from
// the landing URL and persisted so they survive deep navigation (MAX-10728).
export const MSCLKID_COOKIE = 'mx_msclkid'
export const GCLID_COOKIE = 'mx_gclid'
export const GBRAID_COOKIE = 'mx_gbraid'
export const WBRAID_COOKIE = 'mx_wbraid'

const COOKIE_EXPIRY_DAYS = 90

// Cap guards against crafted/garbage URL values (real click ids are ~100 chars).
const MAX_CLICK_ID_LENGTH = 512

const writeCookie = (name, value) => {
  try {
    Cookies.set(name, value, {
      expires: COOKIE_EXPIRY_DAYS,
      domain: '.maximustribe.com',
      secure: true,
      sameSite: 'Lax',
    })
  } catch {
    // Cookies blocked by tracking prevention — non-fatal.
  }
}

const captureAndPersistClickId = (param, cookieName) => {
  if (typeof window === 'undefined') return undefined

  const fromUrl = new URLSearchParams(window.location.search).get(param)?.trim()
  if (fromUrl && fromUrl.length <= MAX_CLICK_ID_LENGTH) {
    writeCookie(cookieName, fromUrl)
    return fromUrl
  }
  return Cookies.get(cookieName) || undefined
}

export const getMicrosoftMatchParameters = () => {
  const params = {}

  const msclkid = captureAndPersistClickId('msclkid', MSCLKID_COOKIE)
  if (msclkid) {
    params.msclkid = msclkid
  }

  return params
}

export const getGoogleMatchParameters = () => {
  const params = {}

  const gclid = captureAndPersistClickId('gclid', GCLID_COOKIE)
  if (gclid) {
    params.gclid = gclid
  }

  const gbraid = captureAndPersistClickId('gbraid', GBRAID_COOKIE)
  if (gbraid) {
    params.gbraid = gbraid
  }

  const wbraid = captureAndPersistClickId('wbraid', WBRAID_COOKIE)
  if (wbraid) {
    params.wbraid = wbraid
  }

  return params
}
